import {cs} from "../../../../../../../../../../../../../common/react/chain-services";
import {StaticTooltipService} from "../../../../../../../../../../common/tooltip3/static-tooltip-service";

export const ConditionalFormatting = ({tile, form, conditionalFormattingConfig}) => ({
    label: "Conditional Formatting",
    iconTooltip: cs(
        [
            "staticTooltip",
            (_, next) =>
                StaticTooltipService({
                    direction: "top",
                    info: `Conditional Rules are applied in the order set in this list. If a cell meets multiple rules then final rule format will show unless the "Stop if True" option is selected`,
                    tooltipBoxWidth: 200,
                    next,
                }),
        ],
        ({staticTooltip}) => (
            <div className="column-settings-info-35d">
                {staticTooltip.renderIcon({
                    icon: <i className="material-icons">info</i>,
                    className: "info-tooltip",
                })}
            </div>
        )
    ),
    render: () => (
        <div className="column-settings-a23">
            <div className="subsection">
                <div className="content">{conditionalFormattingConfig.render()}</div>
            </div>
        </div>
    ),
});
